import { Routes } from "@angular/router";
import { authGuard } from "./core/auth.guard";
import { LoginComponent } from "./features/admin/login.component";

export const routes: Routes = [
  { path: "", pathMatch: "full", redirectTo: "login" },
  { path: "login", component: LoginComponent },
  {
    path: "admin",
    canActivate: [authGuard],
    loadChildren: () => import("./features/admin/admin.routes").then((m) => m.ADMIN_ROUTES)
  },
  { path: "**", redirectTo: "login" }
];
